/* Built In Imports */
import React, { useEffect, useState } from 'react';

/* External Imports */
import { Box, Link } from '@chakra-ui/react';
import PartnerWithusForm from '@landing_pages/csr/components/PartnerWithusForm';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */

/* Services */
import { isVisInViewport } from '@components/Utility/Shared/SharedService';

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const RegisterStickyButton = ({ sectionContent, region, lang, formElement }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [isVisible, setIsVisible] = useState(isMobile ? true : false);

  useEffect(() => {
    if (!isMobile) {
      window.addEventListener('scroll', listenToScroll);
      return () => window.removeEventListener('scroll', listenToScroll);
    }
  }, [isMobile]);

  const listenToScroll = () => {
    const footerDiv = document.getElementById('footer');
    const heightToHideFrom = window.innerHeight;

    const winScroll = document.body.scrollTop ||
      document.documentElement.scrollTop;

    if (!isMobile && winScroll > heightToHideFrom) {
      const footerInViewPort = isVisInViewport(footerDiv);
      if (footerInViewPort) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    } else if (winScroll > 0 && isMobile) {
      setIsVisible(true);
    }
    else {
      setIsVisible(false);
    }
  };

  return (
    isVisible && (
      <Box
        position="fixed"
        top={{ base: 'unset', md: '50%' }}
        bottom={{ base: '0px', md: 'unset' }}
        zIndex="100"
        right={{ base: 'unset', md: '0', xl: '0' }}
        left={{ base: '50%', md: 'unset' }}
        width={{ base: '100%', md: '158px' }}
        height={{ base: '79px', md: '78px' }}
        transform={{ base: 'translateX(-50%)', md: 'none' }}
        background={{ base: '#FFEBC7', md: 'none' }}
        display={'flex'}
        justifyContent={'center'}
        alignContent={'center'}
      >
        <Link
          region={region}
          lang={lang}
          bg="#BB3E03"
          fontFamily="FedraSansStd-medium"
          color="#ffffff"
          fontSize="18px"
          _hover={{ bgColor: '#FBAD2E' }}
          pt="16px"
          pb="12px"
          px="12px"
          lineHeight={'auto'}
          borderRadius={{ base: '5px', md: '5px 0px 0px 5px' }}
          display="flex"
          flexDir="column"
          border="0px"
          textAlign="center"
          m="10px auto"
          ml={{ base: '0px', md: 'auto' }}
          mr={{ base: '15px', md: 'auto' }}
          w={{ base: '206px', md: '100%' }}
          height={{ base: '60px', md: '78px' }}
          alignItems={'center'}
          onClick={openModal}
        >
          {sectionContent[0]?.buttonText}
        </Link>
        <PartnerWithusForm isOpen={isOpen} onClose={closeModal} formElement={formElement} />
      </Box>
    )
  );
};

export default React.memo(RegisterStickyButton);
